import { FC } from "react";
import { IOpsProps } from "../IOpsProps";
import NotYetImpl from "../not-yet-impl/NotYetImpl";
import Operation from "../Operation";

export type ContractOps =
    'add_admin'
  | 'add_students'
  | 'disassociate_students_from_contract'
  | 'migrate_students'
  | 'remove_admin'
  | 'add_students_with_csv'
  | 'delete_students_with_csv'
  | 'add_contract_admins_to_organizations'
  | 'list_users';

export const contractOpsMap: Record<ContractOps, FC> = {
  add_admin: NotYetImpl,
  add_students: NotYetImpl,
  disassociate_students_from_contract: NotYetImpl,
  migrate_students: NotYetImpl,
  remove_admin: NotYetImpl,
  add_students_with_csv: NotYetImpl,
  delete_students_with_csv: NotYetImpl,
  add_contract_admins_to_organizations: NotYetImpl,
  list_users: NotYetImpl,
};

export interface ContractOpsProps extends IOpsProps {
  ops: ContractOps[];
};

const ContractOps: FC<ContractOpsProps> = (props) => {

  const operations = props.ops.map((value: ContractOps) => {
    return (
      <Operation name={value} key={value}>
        { contractOpsMap[value]({}) }
      </Operation>
    );
  });

  return (
    <>
    {operations}
    </>
  );
}

export default ContractOps;
